import styled from "styled-components";

export const ModalContent = styled.div`
    position: relative;
    display: grid;
    grid-template-rows: auto 1fr;
    gap: 24px;
    overflow: hidden;
    max-height: calc(90vh - 32px);
    width: 100%;
    padding: 4px 0 0;

    @media (max-width: 480px) {
        gap: 16px;
    }
`;

export const ButtonCloseModal = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0;
    border-radius: 4px;
    opacity: 0.7;
    transition: opacity 0.2s;
    z-index: 1;
    &:hover {
        cursor: pointer;
        opacity: 1;
    }
`;

export const ModalTitle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 4px;
    flex-shrink: 0;
    padding-right: 36px;

    h1 {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.25;
        color: ${({ theme }) => theme.colors.interfaceText500};
    }

    p {
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        color: ${({ theme }) => theme.colors.interfaceText300};
        text-align: left;
    }
`;

export const ModalFormScroll = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding-right: 4px;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.interfaceGray300} ${({ theme }) => theme.colors.background};

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.colors.interfaceText200};
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.colors.interfaceGray300};
        border-radius: 4px;
    }
`;

export const ModalForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    margin: 0;

    .input-full {
        width: 100%;
        margin-bottom: 10px;
    }

    .input-full label,
    .input-full input {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .input-full label {
        min-height: 0;
    }

    .input-full input {
        height: 48px;
    }

    .input-full .title {
        font-size: 12px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    .input-full:last-of-type {
        margin-bottom: 0;
    }

    .error-msg {
        color: ${({ theme }) => theme.colors.primaryRed400};
        font-size: 12px;
        margin-top: 2px;
        display: block;
    }

    span {
        color: ${({ theme }) => theme.colors.primaryRed400};
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 8px;
    width: 100%;
    justify-content: flex-end;

    @media (max-width: 480px) {
        flex-direction: column;
        gap: 12px;
    }
`;

export const ModalButtonCancel = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200};
    background: ${({ theme }) => theme.colors.interfacePure0};
    color: ${({ theme }) => theme.colors.interfaceText500};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: ${({ theme }) => theme.colors.interfacePure100};
        border-color: ${({ theme }) => theme.colors.interfaceGray300};
    }

    @media (max-width: 480px) {
        width: 100%;
        min-width: 0;
    }
`;

export const ModalButtonPrimary = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;
    border: none;
    background: ${({ theme }) => theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    @media (max-width: 480px) {
        width: 100%;
        min-width: 0;
    }
`;
